// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"a90ccb25","787":"7a3ae784"}[chunkId] + ".chunk.js";
};